import type {Product} from '@/types/product';

export enum OrderBlockType {
	INTERNET = 'internet',
	CONTRACT_DURATION = 'contractDuration',
	SECURE_INTERNET_LICENSE = 'secure-internet-license',
	TELEVISION = 'television',
	STREAMING = 'streaming',
	VOICE = 'voice',
	BUSINESS = 'business',
	MOBILE = 'mobile',
	STANDING_CHARGE = 'standingCharge'
}

export type OrderBlock = {
	id: string | OrderBlockType,
	index: number,
	products: Product[],
	title: string,
	description: string | null,
	titlePrefix: number | string | null,
	footerDescription: string | null,
	collapse: {
		maxProductAboveFold: number | null,
		collapseText: string,
		expandText: string,
		expandedFooterText: string | null
	}
}
